import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import SectionContainer from '../SectionContainer';
import Field, { hasDataInFields } from '../../Field';
import { AspectRatioWrapper } from '../../../../components';

import css from './SectionPay.module.css';
import img from './images/sit-reading-doodle.svg';

const SectionPay = props => {
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    numColumns,
    title,
    description,
    appearance,
    callToAction,
    blocks,
    isInsideContainer,
    options,
    intl,
  } = props;

  // If external mapping has been included for fields
  // E.g. { h1: { component: MyAwesomeHeader } }
  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);

  const aspectWidth = 1;
  const aspectHeight = 1;
  return (
    <SectionContainer
      id={sectionId}
      className={classNames(className)}
      rootClassName={rootClassName}
      appearance={appearance}
      options={fieldOptions}
    >
      <div className={css.container}>
        <div className={css.left}>
          {hasHeaderFields ? (
            <header className={classNames(css.header, defaultClasses.sectionDetails)}>
              <Field data={title} className={defaultClasses.title} options={fieldOptions} />
              <Field
                data={description}
                className={defaultClasses.description}
                options={fieldOptions}
              />
            </header>
          ) : null}

          <div className={css.blocksWrapper}>
            <div className={css.block}>
              <ul className={css.factors}>
                <li>{intl.formatMessage({ id: 'LandingPage.SectionPay.factors.1' })}</li>
                <li>{intl.formatMessage({ id: 'LandingPage.SectionPay.factors.2' })}</li>
              </ul>
            </div>
          </div>

          {/* <p className={css.description}>
            {intl.formatMessage({ id: 'LandingPage.SectionPay.description' })}
          </p> */}
          <Field
            data={callToAction}
            className={classNames(css.cta, defaultClasses.ctaButton)}
            options={fieldOptions}
          />
        </div>
        <div className={css.right}>
          <AspectRatioWrapper
            className={css.aspectRatioWrapper}
            width={aspectWidth}
            height={aspectHeight}
          >
            <img className={css.rootForImage} alt="sit-reading-doodle" src={img} />
          </AspectRatioWrapper>
        </div>
      </div>
    </SectionContainer>
  );
};

SectionPay.defaultProps = {
  className: null,
  rootClassName: null,
};

SectionPay.propTypes = {
  sectionId: string.isRequired,
  className: string,
  rootClassName: string,
};

export default SectionPay;
